<template>
    <div>
      <h1> 404 ERROR NOT FOUND!!</h1>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue